var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"payment-card__content-img"},[(_vm.icon)?[(_vm.icon.src)?_c('div',{class:[
				'payment-card-icon',
				_vm.getClassNameByColor(_vm.icon.type),
				{
					'without-bg': _vm.icon.withoutBg,
					[_vm.icon.size]: !!_vm.icon.size
				}
			]},[_c('img',{attrs:{"src":_vm.icon.src,"alt":_vm.icon.src}})]):(_vm.icon.type)?_c('span',{class:[
				'icon-' + (_vm.icon.font || _vm.getIconByColor(_vm.icon.type)),
				_vm.getClassNameByColor(_vm.icon.type)
			]}):_vm._e()]:_vm._e(),(_vm.subTitle)?_c('p',{staticClass:"payment-card__content-subtitle"},[_vm._v(_vm._s(_vm.subTitle))]):_vm._e(),(_vm.chips.length)?_c('div',{staticClass:"payment-chips"},_vm._l((_vm.chips),function(i,idx){return _c('span',{key:'btn-item-' + idx,staticClass:"text",class:[
				_vm.getClassNameByColor(i.type),
				(i.action && 'clickable'),
				{ 'mt-0': _vm.subTitle }
			],domProps:{"textContent":_vm._s(i.text)},on:{"click":function($event){return _vm.callAction(i.action)}}})}),0):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }